/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

// Editor dee text
const ClassicEditor = require('@ckeditor/ckeditor5-build-classic');
ClassicEditor
    .create(document.querySelector('#content'))
    .then(editor => {
        console.log(editor);
    })
    .catch(error => {
        console.error(error);
    });

import router from './assets/router.js';


window.Vue = require('vue');


/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))



/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('Cap', require('./components/partials/Cap.vue').default);
Vue.component('CapBlog', require('./components/partials/Cap_blog.vue').default);
Vue.component('Peu', require('./components/partials/Peu.vue').default);

//Pagina principal, index
Vue.component('Index', require('./components/Index.vue').default);
Vue.component('Header', require('./components/index/Header.vue').default);
Vue.component('Intro', require('./components/index/Intro.vue').default);
Vue.component('DescriptionCards', require('./components/index/Description_cards.vue').default);
Vue.component('DescriptionTabs', require('./components/index/Description_tabs.vue').default);
Vue.component('Contacte', require('./components/index/Contacte.vue').default);
Vue.component('About', require('./components/index/About.vue').default);
Vue.component('Blog', require('./components/index/Blog.vue').default);

Vue.component('Noticies', require('./components/Noticies.vue').default);

Vue.component('list-posts', require('./components/PostListComponent.vue').default);
Vue.component('modal-post', require('./components/PostModalComponent.vue').default);

const app = new Vue({
    el: '#app',
    router,
    data: {

    }
});